import { render, staticRenderFns } from "./cancel-favorite.vue?vue&type=template&id=533c0931&"
import script from "./cancel-favorite.vue?vue&type=script&lang=js&"
export * from "./cancel-favorite.vue?vue&type=script&lang=js&"
import style0 from "./cancel-favorite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports